import React, {Component} from 'react';
import {PrimaryButton} from "../buttons/PrimaryButton";

/**
 * "No pudimos cargar esta pantalla", con reintentar.
 *
 * Es el bloque que estrenó el Tablero (commits 8d39217 + 029b711) y nada más: mismas clases, mismo
 * botón, mismo ícono. Se extrajo cuando el mismo estado pasó de una pantalla a cinco (FRONTEND-47),
 * no para inaugurar un sistema.
 *
 * Lo que este componente NO es, a propósito:
 *  - NO conoce el `APIClient` ni el i18n: recibe TEXTO ya traducido. El copy es de cada pantalla
 *    («tus prospectos siguen ahí» no sirve en el Tablero) y sus claves viven en el namespace de cada
 *    una.
 *  - NO tiene `kind` ni tabla de configuración. Esa arquitectura ya existe tres veces en el repo
 *    (`DataExplorerEmptyState`, `MediaPlanEmptyState`, `PortalUsageEmptyState`) y hace falta cuando
 *    cada variante trae ícono, tono y CTA propios. Acá hay UNA variante.
 *  - NO muestra el detalle crudo del backend. `029b711` lo sacó del Tablero: ese texto puede ser el
 *    `detail` en inglés de DRF o un genérico que inventa el propio cliente, y no le dice nada al
 *    usuario. El detalle ya viaja a Sentry desde `APIClient`.
 *
 * OJO: `-as-screen` no es opcional. `.dashboard-empty-message` trae `width: 100vw` porque nació
 * dentro de un `<td>` del table-box, que ya arranca donde termina el sidebar; colgado de un
 * contenedor que YA tiene el padding del sidebar, ese `100vw` se pasa del viewport y `.app-content`
 * lo recorta en silencio.
 *
 * Y va SIEMPRE con `-inline`, que es lo que lo distingue del Tablero: allá el bloque ES la pantalla
 * y arranca en y=0, así que sus 600px de alto fijo lo centran bien. Acá vive debajo de contenido
 * (un encabezado con pestañas, un buscador), y esos 600px empujaban el botón «Reintentar» fuera del
 * viewport -- inalcanzable sin desplazar, medido a 1440 y a 390 (QA-VIS-net-01 y -03).
 */
export class LoadErrorState extends Component {
    render() {
        const {title, text, retryLabel, onRetry} = this.props;
        return (
            <div className="dashboard-empty-message -as-screen -inline">
                <h1>{title}</h1>
                <h2>{text}</h2>
                {/* Sin `onRetry` no hay botón: un "Reintentar" que no reintenta es peor que nada. */}
                {onRetry && <PrimaryButton onClick={onRetry} icon="sync-alt" text={retryLabel}/>}
            </div>
        );
    }
}
